export default "__VITE_ASSET__CT_HreZA__"